import ValidateModule from "./ValidateModule";

import type AjaxRequestBroker from "../AjaxRequestBroker";
import type { IEventChannel } from "../model/Models";
import type {ApiOpts} from "@esWebAPI/es/model/Models";
import type CacheModule from "./CacheModule";

const es = global.es;

export default class GeoShapeModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        this.load = this.load.bind(this);
        this.store = this.store.bind(this);
    }

    /**
     * Get the resource from the server
     * 
     * @param key
     * 
     * @returns a jquery deferred object resolved when the request has completed
     */
    load(key: string) {
        if (!ValidateModule.checkMandatoryArg(key)) {
            return es.util.deferred.rejected();
        }
        
        const url = es.api.getURL(this.resourceName) + "/" + key;
        return this.cache.doGet(this.rqBroker, this.resourceName, url, key);
    }
    
    /**
     * POST a new resource to the server
     * 
     * @param resourceObj
     * @param opts
     * 
     * @returns a jquery deferred object resolved when the request has completed
     */
    store(resourceObj, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(resourceObj)) {
            return es.util.deferred.rejected();
        }

        const url = es.api.getURL(this.resourceName);
        
        return this.rqBroker.doPost({
            url: url,
            opts: opts,
            data: resourceObj
        }).done((geoShape) => {
            this.cache.set(this.resourceName, geoShape.key, geoShape);
        });
    }
}
